<script>
import { mapGetters } from 'vuex';
import NavigationProgressBar from '@ui-kit/components/steppers/NavigationProgressBar.vue';

import { dynamicFormStoreTypes } from '@/store/types';

export default {
  name: 'ProgramProgressBar',

  components: {
    NavigationProgressBar,
  },

  setup() {
    const progressPages = [
      'eco_area_concern',
      'onboarding2_stepper_about_you',
      'onboarding2_stepper_survey',
      'onboarding2_stepper_call',
      'onboarding2_stepper_choose_pt',
      'onboarding2_stepper_address',
      'onboarding2_stepper_summary',
    ];

    return {
      progressPages,
    };
  },

  computed: {
    ...mapGetters({
      currentFormPageIndex: dynamicFormStoreTypes.getters.GET_CURRENT_PAGE_INDEX,
      pages: dynamicFormStoreTypes.getters.GET_FORM_PAGES,
    }),

    showProgress() {
      return this.$pageInfo.currentPageName && this.progressPages.includes(this.$pageInfo.currentPageName);
    },

    currentPageIncreaseProgress() {
      const isDynamicFormStep = this.$pageInfo.currentPageName === 'onboarding2_stepper_survey';
      const sizePages = (this.pages && this.pages.length) || 1;
      const currentFormIndex = this.currentFormPageIndex || 0;

      return isDynamicFormStep ? currentFormIndex / sizePages : 0;
    },

    currentPage() {
      return this.progressPages.indexOf(this.$pageInfo.currentPageName) + this.currentPageIncreaseProgress;
    },
  },
};
</script>

<template>
  <navigation-progress-bar
    v-if="showProgress"
    class="program-enrolment-progress"
    :current-page="currentPage"
    :max-page="progressPages.length - 1"
  />
</template>

<style scoped>
  .program-enrolment-progress {
    margin-top: -.25rem;
    margin-bottom: -.25rem;
  }
</style>
